/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Air_Handler_Unit_Elec_Conso_LabelInputs */



/**
* | output |
* | --- |
* | "Elec consumption" |
*
* @param {Air_Handler_Unit_Elec_Conso_LabelInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const air_handler_unit_elec_conso_label = /** @type {((inputs?: Air_Handler_Unit_Elec_Conso_LabelInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Air_Handler_Unit_Elec_Conso_LabelInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Elec consumption")
	return /** @type {LocalizedString} */ ("Conso élec")
});